var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Browser, Internet, Web, Network, Lock",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16339",
    fill: "none",
    stroke: "#656565",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12357",
    d: "M33.333 35H6.666a3.332 3.332 0 01-3.333-3.333V8.333A3.332 3.332 0 016.666 5h26.667a3.332 3.332 0 013.333 3.333v23.334A3.332 3.332 0 0133.333 35z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12358",
    d: "M3.333 13.333h33.333"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12359",
    d: "M7.964 9.15a.008.008 0 10.008.008.008.008 0 00-.008-.008"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12360",
    d: "M12.203 9.15a.008.008 0 00-.008.008.009.009 0 00.008.008.009.009 0 100-.017"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12361",
    d: "M16.434 9.15a.008.008 0 10.008.008.008.008 0 00-.008-.008"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12362",
    d: "M22.849 23.334v-2.15a2.872 2.872 0 00-3.845-2.668 2.96 2.96 0 00-1.853 2.807v2.011"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12363",
    d: "M23.333 29.166h-6.666A1.667 1.667 0 0115 27.5V25a1.667 1.667 0 011.667-1.667h6.667A1.667 1.667 0 0125 25v2.5a1.667 1.667 0 01-1.667 1.666z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12364",
    d: "M0 0h40v40H0z",
    fill: "none"
  })));
}
export default SvgInternet;


//////////////////
// WEBPACK FOOTER
// ./src/icons/internet.svg
// module id = 203
// module chunks = 13